import {BlockMath, InlineMath} from "react-katex";

const SupervisedLearningIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <h1 className="tw-header font-bold text-gray-900 mb-4">Supervised Learning</h1>
            <p className="text-gray-600 tw-subtitle text-justify">
                Supervised learning is like having a really patient teacher who shows you tons of examples
                with the correct answers. Imagine you're learning to recognize cats in photos - your teacher
                shows you thousands of images, each labeled "cat" or "not cat." Eventually, you get so good
                at spotting the patterns that you can identify cats in photos you've never seen before.
            </p>
            <hr className="mt-2 mb-2"/>
            <p className="tw-subtitle text-gray-600">
                The mathematical foundation involves finding a function <InlineMath math="f"/> that maps
                inputs <InlineMath math="x"/> to outputs <InlineMath math="y"/>. Given training data
                <InlineMath math="\{(x_1, y_1), (x_2, y_2), ..., (x_n, y_n)\}"/>, we want to minimize
                the prediction error:
            </p>
            <BlockMath math="L(f) = \frac{1}{m}\sum_{i=1}^{m} (f(x_i) - y_i)^2"/>
            <p className="tw-subtitle text-gray-600">
                This breaks down into two main flavors: <strong>regression</strong> (predicting continuous
                values like house prices) and <strong>classification</strong> (predicting categories like
                spam vs. not spam). The beauty of supervised learning is that it learns from examples,
                just like humans do - except it can process millions of examples without getting bored
                or needing coffee breaks!
            </p>
        </div>
    )
}

export default SupervisedLearningIntro;